import { SelectProps } from 'antd';
import { cloneDeep, isEmpty, mapValues, omit, pickBy, reject, values } from 'lodash';

import { INETWORK_CONFIGURES } from '@api/emp/types';

export function cleanAndValidateConfiguration(
  networkConfiguresData: INETWORK_CONFIGURES,
  urlConditionValue: string,
  urlConditionOptions: SelectProps['options'] = [],
) {
  const cleanConfiguration = mapValues(
    pickBy(networkConfiguresData.configuration, (value, key) => {
      const isAllCondition = urlConditionValue === urlConditionOptions[0].value;
      return (
        !(key === 'target_url' && isAllCondition) &&
        !isEmpty(value) &&
        value.some((item) => item && item !== '')
      );
    }),
    (arr) => reject(arr, (item) => item === ''),
  );

  const validConfigRules = values(omit(cloneDeep(cleanConfiguration), 'target_url')).filter(
    (value) => !isEmpty(value) && value.some((item) => item !== ''),
  );

  return { cleanConfiguration, validConfigRules };
}
